import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import BrandedAppImageAndContent from 'src/app/organisms/Homepage/BrandedAppImageAndContent/BrandedAppImageAndContent';

const BrandedApp = (): JSX.Element => (
  <SectionLayout
    padding={['spacing-7xl', 'spacing-none']}
    paddingMd={['spacing-4xl', 'spacing-none']}
    maxWidth='width-3xl'
  >
    <Stack
      align='center'
      justify='center'
      padding={['spacing-none', 'spacing-4xl']}
      paddingSm={['spacing-none', 'spacing-xl']}
    >
      <BrandedAppImageAndContent />
    </Stack>
  </SectionLayout>
);

export default BrandedApp;
